"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdentResolverReference = void 0;
exports.IdentResolverReference = {
    "time": "time",
    "person": "person",
    "measure": "measure",
    "kom": "kom"
};
